import type { IsoDate } from '@/api/common.ts';

export const pad = (value: number) => String(value).padStart(2, '0');

// Local calendar date; toISOString() would use UTC and can be off by a day around midnight.
export const toIsoDate = (date: Date): IsoDate =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const getToday = (): IsoDate => toIsoDate(new Date());

export const getDaysAgo = (days: number): IsoDate => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return toIsoDate(date);
};

export const getStartOfYear = (): IsoDate => `${getToday().slice(0, 4)}-01-01`;

export const addDays = (date: IsoDate, days: number): IsoDate => {
    const day = new Date(`${date}T00:00:00Z`);
    day.setUTCDate(day.getUTCDate() + days);
    return day.toISOString().slice(0, 10);
};

// Due before today; whether it's done is the caller's to check.
export const isOverdue = (dueDate: IsoDate | null) => dueDate !== null && dueDate < getToday();

// Whole calendar days from `from` to `to` (negative when `to` is earlier).
export const daysBetween = (from: IsoDate, to: IsoDate) =>
    Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);

// Since Monday, today included.
export const isThisWeek = (date: IsoDate) => {
    const daysAgo = daysBetween(date, getToday());
    return daysAgo >= 0 && daysAgo <= (new Date().getDay() + 6) % 7;
};
